import { BookingAvailabilityItemModel as i } from "./bookingAvailabilityItem.model.js";
import { Adapter as t } from "../../../adapter.js";
class r extends t {
  adapt(e) {
    return new i({
      id: e.id,
      name: e.name,
      status: e.status,
      address: e.address,
      distance: e.distance,
      phone: e.phone,
      alternativeTimes: e.alternative_times,
      alternativePeople: e.alternative_people,
      zones: e.zones
    });
  }
  serialize(e) {
  }
}
export {
  r as BookingAvailabilityItemAdapter
};
//# sourceMappingURL=bookingAvailabilityItem.adapter.js.map
